var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneboardAppealsImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 933.99 881.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14{fill:#007cff;}.cls-10,.cls-12,.cls-2,.cls-3,.cls-5{fill:#fff;}.cls-2{opacity:0.9;}.cls-3{opacity:0.7;}.cls-14,.cls-4{opacity:0.4;}.cls-5{opacity:0.8;}.cls-6{opacity:0.3;}.cls-7{fill:#ffc3bd;}.cls-8{fill:#1a2e35;}.cls-11,.cls-9{opacity:0.2;}.cls-12{opacity:0.5;}.cls-13{fill:#ff847f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0417\\u0430\\u044F\\u0432\\u043A\\u0438"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.4,339.06c-53.26,295.79,303,106.88,417.89,130.24,82.47,16.75,165,171.77,277.1,176,117.84,4.48,207.74-109.15,222.09-211.43C954.16,279.33,738.16-27.86,548.55,2,404.74,24.71,426.63,228.31,292.17,270.71,207.63,297.36,44.4,178,15.4,339.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.4,339.06c-53.26,295.79,303,106.88,417.89,130.24,82.47,16.75,165,171.77,277.1,176,117.84,4.48,207.74-109.15,222.09-211.43C954.16,279.33,738.16-27.86,548.55,2,404.74,24.71,426.63,228.31,292.17,270.71,207.63,297.36,44.4,178,15.4,339.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.32,
    y: 504.8,
    width: 2.63,
    height: 40.07,
    transform: "translate(-60.95 3.98) rotate(-6.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.55,
    y: 559.45,
    width: 2.63,
    height: 20.21,
    transform: "translate(-66.11 4.89) rotate(-6.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.87,423.64l-3.1-8.69a28.08,28.08,0,0,0-29.72-18.47L26.52,410.93A28.09,28.09,0,0,0,1.89,442.1L37.05,742.71a19.26,19.26,0,0,0,21.37,16.9l442-51.69a19.28,19.28,0,0,0,16.9-21.38l-30.4-259.87a19.26,19.26,0,0,0-21.37-16.89l-256.64,30A24.57,24.57,0,0,1,182.87,423.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.37,
    y: 304.93,
    width: 142.39,
    height: 196.17,
    transform: "translate(-75.98 36.03) rotate(-11.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 73.37,
    y: 304.93,
    width: 142.39,
    height: 196.17,
    transform: "translate(-75.98 36.03) rotate(-11.27)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.57,339.21l-86,17.15a7.71,7.71,0,0,1-9.06-6.05h0a7.71,7.71,0,0,1,6.05-9.06l86-17.14a7.7,7.7,0,0,1,9.06,6.05h0A7.7,7.7,0,0,1,176.57,339.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.91,371l-86,17.14a7.71,7.71,0,0,1-9.06-6.05h0a7.71,7.71,0,0,1,6-9.06l86-17.14A7.71,7.71,0,0,1,189,362h0A7.71,7.71,0,0,1,182.91,371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.25,402.84l-86,17.14a7.7,7.7,0,0,1-9.06-6.05h0a7.71,7.71,0,0,1,6-9.06l86-17.14a7.71,7.71,0,0,1,9.06,6h0A7.71,7.71,0,0,1,189.25,402.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.59,434.65l-86,17.14a7.7,7.7,0,0,1-9.06-6h0a7.7,7.7,0,0,1,6-9.06l86-17.15a7.71,7.71,0,0,1,9.06,6h0A7.71,7.71,0,0,1,195.59,434.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.42,471.15l-62.51,12.46a7.71,7.71,0,0,1-9.06-6.05h0a7.71,7.71,0,0,1,6.05-9.06L175.41,456a7.71,7.71,0,0,1,9.06,6h0A7.71,7.71,0,0,1,178.42,471.15Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 265.76,
    y: 264.56,
    width: 142.39,
    height: 196.17,
    transform: "translate(-46.06 49.04) rotate(-7.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 265.76,
    y: 264.56,
    width: 142.39,
    height: 196.17,
    transform: "translate(-46.06 49.04) rotate(-7.79)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.77,300.89l-86.9,11.9a7.7,7.7,0,0,1-8.67-6.59h0a7.69,7.69,0,0,1,6.58-8.67l86.91-11.9a7.7,7.7,0,0,1,8.67,6.59h0A7.69,7.69,0,0,1,372.77,300.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.17,333l-86.9,11.9a7.72,7.72,0,0,1-8.68-6.59h0a7.72,7.72,0,0,1,6.59-8.68l86.9-11.89a7.7,7.7,0,0,1,8.68,6.59h0A7.69,7.69,0,0,1,377.17,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.61,373.79l-23.94,3.27a7.7,7.7,0,0,1-8.68-6.58h0a7.72,7.72,0,0,1,6.59-8.68l23.95-3.27a7.7,7.7,0,0,1,8.67,6.58h0A7.7,7.7,0,0,1,318.61,373.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.05,367.43l-23.95,3.28a7.69,7.69,0,0,1-8.67-6.59h0a7.69,7.69,0,0,1,6.58-8.67L363,352.17a7.69,7.69,0,0,1,8.67,6.59h0A7.7,7.7,0,0,1,365.05,367.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386,397.31l-86.9,11.89a7.7,7.7,0,0,1-8.68-6.58h0a7.71,7.71,0,0,1,6.59-8.68l86.9-11.89a7.7,7.7,0,0,1,8.68,6.58h0A7.72,7.72,0,0,1,386,397.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.62,432.7l-63.15,8.64a7.7,7.7,0,0,1-8.68-6.59h0a7.7,7.7,0,0,1,6.59-8.67l63.15-8.64A7.69,7.69,0,0,1,373.2,424h0A7.7,7.7,0,0,1,366.62,432.7Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.47,
    y: 290.02,
    width: 142.39,
    height: 196.17,
    transform: "translate(-32.95 18.71) rotate(-4.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.47,
    y: 290.02,
    width: 142.39,
    height: 196.17,
    transform: "translate(-32.95 18.71) rotate(-4.98)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.47,328.19l-87.38,7.61a7.7,7.7,0,0,1-8.35-7h0a7.7,7.7,0,0,1,7-8.34l87.38-7.62a7.7,7.7,0,0,1,8.34,7h0A7.71,7.71,0,0,1,237.47,328.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.28,360.5l-87.38,7.62a7.7,7.7,0,0,1-8.34-7h0a7.71,7.71,0,0,1,7-8.34L239,345.16a7.7,7.7,0,0,1,8.34,7h0A7.7,7.7,0,0,1,240.28,360.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.1,392.82l-87.38,7.61a7.69,7.69,0,0,1-8.34-7h0a7.69,7.69,0,0,1,7-8.34l87.38-7.62a7.7,7.7,0,0,1,8.34,7h0A7.7,7.7,0,0,1,243.1,392.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.92,425.13l-87.39,7.62a7.71,7.71,0,0,1-8.34-7h0a7.71,7.71,0,0,1,7-8.34l87.38-7.61a7.69,7.69,0,0,1,8.34,7h0A7.7,7.7,0,0,1,245.92,425.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.85,459.53l-63.5,5.53a7.69,7.69,0,0,1-8.34-7h0a7.7,7.7,0,0,1,7-8.34l63.5-5.54a7.71,7.71,0,0,1,8.35,7h0A7.71,7.71,0,0,1,224.85,459.53Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.38,
    y: 277.99,
    width: 142.39,
    height: 196.17,
    transform: "translate(-17.71 18.16) rotate(-2.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 296.38,
    y: 277.99,
    width: 142.39,
    height: 196.17,
    transform: "translate(-17.71 18.16) rotate(-2.76)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.67,317.71l-87.61,4.23a7.72,7.72,0,0,1-8.07-7.33h0a7.7,7.7,0,0,1,7.32-8.06l87.61-4.23a7.71,7.71,0,0,1,8.07,7.32h0A7.71,7.71,0,0,1,408.67,317.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.23,350.11l-87.61,4.23a7.7,7.7,0,0,1-8.06-7.33h0a7.69,7.69,0,0,1,7.32-8.06l87.61-4.23a7.7,7.7,0,0,1,8.06,7.32h0A7.7,7.7,0,0,1,410.23,350.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.33,385.57l-24.15,1.17a7.72,7.72,0,0,1-8.06-7.33h0a7.7,7.7,0,0,1,7.32-8.06l24.14-1.17a7.72,7.72,0,0,1,8.07,7.33h0A7.71,7.71,0,0,1,348.33,385.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.14,383.31,371,384.48a7.72,7.72,0,0,1-8.07-7.33h0a7.7,7.7,0,0,1,7.32-8.06l24.14-1.17a7.72,7.72,0,0,1,8.07,7.33h0A7.71,7.71,0,0,1,395.14,383.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.36,414.91l-87.61,4.22a7.7,7.7,0,0,1-8.07-7.32h0a7.7,7.7,0,0,1,7.33-8.06l87.61-4.23a7.69,7.69,0,0,1,8.06,7.32h0A7.7,7.7,0,0,1,413.36,414.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391,448.46l-63.67,3.07a7.69,7.69,0,0,1-8.06-7.32h0a7.69,7.69,0,0,1,7.32-8.06l63.67-3.07a7.69,7.69,0,0,1,8.06,7.32h0A7.69,7.69,0,0,1,391,448.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.32,429.21l-2.26-8.51c-3.21-12.06-14.7-19.53-27.7-18L68.84,417.14C53.43,419,41.23,432.63,41.59,447.72l7,294.26c.25,10.34,9,17.72,19.58,16.49l442-51.7c10.56-1.23,18.93-10.62,18.68-21l-6.05-254.38c-.25-10.34-9-17.72-19.58-16.49L246.54,445C235.17,446.29,225.13,439.76,222.32,429.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.32,429.21l-2.26-8.51c-3.21-12.06-14.7-19.53-27.7-18L68.84,417.14C53.43,419,41.23,432.63,41.59,447.72l7,294.26c.25,10.34,9,17.72,19.58,16.49l442-51.7c10.56-1.23,18.93-10.62,18.68-21l-6.05-254.38c-.25-10.34-9-17.72-19.58-16.49L246.54,445C235.17,446.29,225.13,439.76,222.32,429.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M654.44,287.74c-1.91,9.61-4,19.05-6.25,28.49s-4.55,18.87-7.06,28.24l-3.82,14-.5,1.8c-.23.77-.49,1.55-.79,2.35a23.7,23.7,0,0,1-2.53,5,17.88,17.88,0,0,1-4.82,4.91,15.66,15.66,0,0,1-7.06,2.55,20.31,20.31,0,0,1-11.08-2.45,39.37,39.37,0,0,1-7.19-5,64.82,64.82,0,0,1-10.52-11.86l7.19-6.47a88.41,88.41,0,0,0,11.11,7.38,26,26,0,0,0,5.32,2.3c1.59.52,3,.45,3,.19,0-.1-.25-.1-.38-.09s-.12-.06,0-.43.3-.9.47-1.59l.59-2.84,3-14.12,6.07-28.23c2-9.4,4.08-18.83,6.13-28.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M645.79,258.21c-22,16.88-21.16,48.68-21.16,48.68l39.44,9.43s12.1-32,7.19-43.69C666.14,260.41,658.2,248.71,645.79,258.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M602,349.88l-14.5-14.5-7.82,22.68s12.24,6.61,23.95.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "567.47 333.14 564.81 351.07 579.72 358.06 587.54 335.38 567.47 333.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "773.58 858.32 751.4 860.49 728.32 807.7 750.5 805.53 773.58 858.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "916.45 780.28 899.79 795.92 863.83 756.39 880.49 740.75 916.45 780.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M892.1,788.41l12.52-22.55a1.82,1.82,0,0,1,2.26-.84l19.27,7.33a3.69,3.69,0,0,1,1.79,5.2c-4.5,7.79-7.07,11.33-12.57,21.24-3.39,6.11-10,20.1-14.66,28.53-4.58,8.24-13.26,4.25-12.07.32C894,810,893,800.23,891.48,792.45A6,6,0,0,1,892.1,788.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M748.45,853.63h27.24a2.25,2.25,0,0,1,2.15,1.66l5.92,21.55a3.38,3.38,0,0,1-3.32,4.31c-9.6.09-14.15.05-26.13.05H717.7c-10,0-12-10.07-7.91-11,18.46-4.08,29.11-9.72,34.8-15.09A5.61,5.61,0,0,1,748.45,853.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "728.33 807.71 740.22 834.92 763.36 834.92 750.52 805.54 728.33 807.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "880.5 740.76 863.84 756.41 882.38 776.77 899.05 761.12 880.5 740.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M652.45,254.94s-10,4.38,23.47,136.72l92.91-8c-4.83-37.67-6.89-61,4.47-140.15a274.87,274.87,0,0,0-39.9-1.78c-15.7.6-28.55,1.2-42.19,3.65C673.23,248.56,652.45,254.94,652.45,254.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M733.4,241s5.27.09,11.49.09c3.74,5.78-8.42,31-28.53,47.54a50.78,50.78,0,0,0-16.15-23.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M691.22,245s-2.35.33-8,1.62c-3.74,5.77-10.07,30.39,1,43a49.66,49.66,0,0,1,16-24.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M725.11,194.55c-1.49,13.8-2,38.9,8.29,47.14,0,0-11,11.2-33.19,23.57-16.15-11.16-9-19.92-9-19.92,14.82-4.93,13.46-16.12,9.91-26.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.84,265.33s13.62-14.83,20.65-12,1.6,7.93,1,12.7,2.73,17.51-6.7,14.2S699.84,265.33,699.84,265.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.28,265s-6.42-11.38-13.37-9.86-2.82,5.52-2.2,9.79c.79,5.5-5,16,3.38,13.06C695.25,275.13,699.28,265,699.28,265Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M695.75,262.57c.07,3.17.53,5.37,1.3,6.68a30.2,30.2,0,0,0,2.23-4.21,30.51,30.51,0,0,0-3.29-4.57A5.87,5.87,0,0,0,695.75,262.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.79,260.54c-2.91,2.57-4.95,4.79-4.95,4.79a38.69,38.69,0,0,0,2.66,4.47c1.15-1,2.1-2.76,2.52-5.87A5.85,5.85,0,0,0,704.79,260.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.66,270c-1.92,0-3.11-2.11-3.25-7.1s3.7-2.22,3.7-2.22,5.11-2.67,4.24,3.4C703.68,268.8,701.65,270,699.66,270Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M715.33,204.48l-14.2,14.4a43.75,43.75,0,0,1,2,7.38c5.71-1.34,14-7.27,14.07-13.38A24.38,24.38,0,0,0,715.33,204.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M703.17,147.92s-15.46,21.48-18,31.12c-10.55,6.13-12.68-24.13-7.08-42.79C695.4,147,703.17,147.92,703.17,147.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M737.25,173c-5.76,22.05-7.72,31.5-21.25,40.74-20.34,13.9-46.16,2-47.11-21.32-.85-21,8.71-53.52,32.3-58.11C724.44,129.77,743,150.93,737.25,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M749.24,164.18s-11.08,17.95-12.57,25.75c-8,5.47-11.43-18.46-8-33.61C732.33,143,749.24,164.18,749.24,164.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M744.82,151.68c-3.19,2.43-6.59-6.55-3.39-13.41-6.14.38-13.5-3.26-11.93-9.17-12.06,4-16.54-8.23-15.15-16.73,1.68-10.27,10.69-12.54,16-9.83.1-4.61,11.68-14.27,16.12-6.72,8.25-2.91,21.53-2,21.26,8.12,5.45.17,21.54,6.34,15.61,20.8,7.1.43,10.95,9.45,7,16.27,9.09,5.33,5.72,14.6,2.26,17.84,3.27,6.82-6.69,17-12,15.75-4,6.19-10.22,10.84-14.26,5.56-7.85,5.72-16.65-1.53-14.66-7.12C742.79,171.57,733.81,156.89,744.82,151.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M758,130c5.79,9.66,5.31,20.6-1.07,24.42s-16.25-.91-22-10.57-5.31-20.6,1.07-24.42S752.17,120.32,758,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M704.2,145.21c-.35,2.78-8,2.06-10.17-2.82-3.14,3.3-10.56,5-13.1,1.42-4.28,8.05-12.88,5.94-15.13,2.07s-3.7-11,.76-12.41c-2.6-2.24-1.82-12.7,5-11.39,2.85-5.57,10.64-11.91,16.32-7,3.09-2.69,15.45-8,20.53,1.9,4.13-3.41,11.43-1.09,13.19,4.14,8.05-2.1,11.53,4,11.5,7.3,5.72,1.56,6.1,11.43,2.5,13.54,1.35,5,.64,10.34-4.61,9.9-1,6.7-10,7.74-12.13,4.08C713.1,159.8,701.17,153.29,704.2,145.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M690.6,126.23c6.55-9.06,30.39-12.82,51,.75,18.62,12.23,17.41,40.61,2.61,39.11s-29.44-18.88-29.44-18.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M739.07,192.88a16.65,16.65,0,0,1-9.79,8.12c-5.59,1.69-8.5-3.29-7-8.63,1.31-4.8,5.8-11.47,11.46-10.81S741.55,188.08,739.07,192.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.92,391.66s-31.43,139.05-10.45,237.08C679.53,694.4,730.21,827,730.21,827l39.63-1s-38.37-139.19-46.3-193.93C710,538.45,744,385.78,744,385.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M712.17,419.74,732,451c-5,32.4-10.05,72.93-11.33,111.93C692.78,513,706,446.15,712.17,419.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "724.62 829.09 773.58 827.84 770.74 812.8 720.8 815.17 724.62 829.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.24,390.18s18.44,147.47,58.41,228c32.28,65,118.44,157.6,118.44,157.6l22-22.69s-58.2-100.61-82.19-143.8c-58.84-105.92-10.75-186.75-44.1-225.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "870.86 778.79 899.28 751.08 889.85 738.25 859.71 768.33 870.86 778.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M769.75,378.05l4.91,8c.38.61-.33,1.34-1.4,1.43l-97.44,8.43c-.83.07-1.56-.28-1.66-.8l-1.56-8.25c-.11-.57.58-1.12,1.49-1.2l94.08-8.13A1.69,1.69,0,0,1,769.75,378.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M769.75,378.05l4.91,8c.38.61-.33,1.34-1.4,1.43l-97.44,8.43c-.83.07-1.56-.28-1.66-.8l-1.56-8.25c-.11-.57.58-1.12,1.49-1.2l94.08-8.13A1.69,1.69,0,0,1,769.75,378.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M758,389.66l2.52-.21c.5-.05.86-.34.8-.65l-2.11-10.7c-.07-.32-.53-.54-1-.49l-2.52.21c-.5.05-.86.34-.8.65l2.12,10.7C757.06,389.49,757.52,389.71,758,389.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683,396.15l2.52-.21c.5-.05.86-.34.8-.65l-2.11-10.7c-.07-.32-.53-.54-1-.49l-2.52.21c-.5.05-.86.34-.8.65l2.12,10.7C682,396,682.48,396.2,683,396.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.5,392.91l2.52-.22c.5,0,.86-.33.8-.65l-2.11-10.7c-.07-.31-.53-.53-1-.49l-2.52.22c-.5,0-.86.33-.8.65l2.12,10.7C719.54,392.73,720,393,720.5,392.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M699.93,172.22c-.36,1.82-1.61,3.1-2.8,2.87s-1.86-1.9-1.5-3.71,1.61-3.1,2.79-2.87S700.29,170.4,699.93,172.22Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 677.24,
    cy: 167.76,
    rx: 3.35,
    ry: 2.19,
    transform: "translate(381.98 799.92) rotate(-78.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M678.39,164.67l-4.12-2.11S675.84,166.41,678.39,164.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M686.45,172.71s-4.62,7.22-8.76,10.33c2,2.71,6.24,2.49,6.24,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M692.33,194.19a15.09,15.09,0,0,0,10.36-3.94.45.45,0,0,0-.65-.63A14.8,14.8,0,0,1,689.11,193a.45.45,0,0,0-.53.36.45.45,0,0,0,.36.53A17.23,17.23,0,0,0,692.33,194.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M712.27,165.18a.86.86,0,0,0,.46-.14.9.9,0,0,0,.31-1.24,10.6,10.6,0,0,0-8.19-5.29.91.91,0,0,0-.07,1.81,8.76,8.76,0,0,1,6.71,4.42A.91.91,0,0,0,712.27,165.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M673.69,157.9a.85.85,0,0,0,.43-.12,8.92,8.92,0,0,1,8-.53.89.89,0,0,0,1.22-.37.92.92,0,0,0-.38-1.23,10.65,10.65,0,0,0-9.74.55.91.91,0,0,0,.45,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M777.25,264.62c1.75,1.71,3,3,4.34,4.56s2.59,3,3.82,4.56c2.47,3.06,4.8,6.22,7,9.45A156.22,156.22,0,0,1,804,303.63,133.82,133.82,0,0,1,812,325.78c1,3.82,1.9,7.66,2.55,11.55.89,4.09,1.24,10.72-1.77,16.34a21.31,21.31,0,0,1-5.78,6.88,28.32,28.32,0,0,1-6.75,3.88,48.59,48.59,0,0,1-12.84,3.05,108.31,108.31,0,0,1-23.59-.3,241.48,241.48,0,0,1-44.2-9.4l2.36-9.37c7,1.16,14.27,2.25,21.42,3s14.32,1.42,21.38,1.57,14.06,0,20.43-1.12a32.42,32.42,0,0,0,8.42-2.51c2.32-1.14,3.53-2.45,3.81-3.38a5.3,5.3,0,0,0,.32-1.87c0-.41,0-.89-.1-1.39s-.17-1-.4-1.95c-.73-3.32-1.68-6.6-2.7-9.85a141.67,141.67,0,0,0-18.42-36.6q-2.89-4.26-6.11-8.26-1.59-2-3.26-3.91c-1-1.23-2.3-2.62-3.15-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M727.89,349.83l-18.12-9.6-.81,24s12.8.81,20.31-5.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "696.15 478.73 711.11 316.38 679.18 291.94 581.73 282.96 564.81 466.63 696.15 478.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "696.15 478.73 711.11 316.38 679.18 291.94 581.73 282.96 564.81 466.63 696.15 478.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "711.11 316.38 679.18 291.94 687.55 321.19 711.11 316.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 576.23,
    cy: 455.21,
    r: 39.8,
    transform: "translate(-66.39 99.83) rotate(-9.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 576.23,
    cy: 455.21,
    r: 31.74,
    transform: "translate(-158.11 455.21) rotate(-38.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "595.84 452.42 581.84 450.78 583.48 436.78 573.44 435.6 571.8 449.6 557.79 447.96 556.61 458 570.62 459.64 568.98 473.65 579.01 474.82 580.66 460.82 594.66 462.46 595.84 452.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M687.27,350h0a10.86,10.86,0,0,1-11.81,9.82l-71.09-6.54a10.86,10.86,0,0,1-9.82-11.81h0a10.87,10.87,0,0,1,11.81-9.83l71.09,6.54A10.87,10.87,0,0,1,687.27,350Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M663.05,379.36h0a10.87,10.87,0,0,1-11.81,9.83l-49.68-4.57a10.87,10.87,0,0,1-9.82-11.82h0A10.87,10.87,0,0,1,603.56,363l49.67,4.57A10.86,10.86,0,0,1,663.05,379.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "698.73 341.67 701.45 359.58 708.96 364.21 709.77 340.23 698.73 341.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M773.3,243.47c11.39,2,27.35,34.68,27.35,34.68l-28.71,26s-22.84-24.91-21.62-39.75C751.35,251.77,758.79,240.91,773.3,243.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M887.71,800.54a2.77,2.77,0,0,0,.89-.15c2.72-.92,4.51-6,5.33-8.88a.45.45,0,0,0-.64-.53c-.83.44-8.11,4.33-8.35,7.2a1.78,1.78,0,0,0,.78,1.61A3.3,3.3,0,0,0,887.71,800.54Zm5-8.23c-1.26,4-2.89,6.7-4.44,7.22a2.14,2.14,0,0,1-2-.46.88.88,0,0,1-.42-.81C886,796.49,890.25,793.72,892.75,792.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M886.59,793.45a16.36,16.36,0,0,0,7.14-1.68.44.44,0,0,0,.22-.39.48.48,0,0,0-.23-.39c-.25-.14-6-3.3-9.11-2.2a2.69,2.69,0,0,0-1.7,1.61,1.8,1.8,0,0,0,.41,2.23A5.27,5.27,0,0,0,886.59,793.45Zm5.91-2.07c-2.46,1-7.24,1.7-8.59.56-.23-.19-.45-.5-.16-1.2a1.82,1.82,0,0,1,1.16-1.1C887,788.89,890.86,790.58,892.5,791.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M736.37,858a36.15,36.15,0,0,0,7.43-.94.45.45,0,0,0,.1-.85c-1.12-.53-11-5.1-13.49-3.41a1.48,1.48,0,0,0-.65,1.4,3.31,3.31,0,0,0,1.35,2.55A9,9,0,0,0,736.37,858Zm5.88-1.55c-2.94.55-8.36,1.26-10.6-.42a2.43,2.43,0,0,1-1-1.88.6.6,0,0,1,.25-.6C732.3,852.64,738.15,854.69,742.25,856.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.7,857.11a.48.48,0,0,0,.3-.11.47.47,0,0,0,.14-.45c-.09-.41-2.33-10.16-7.7-9.53-1.34.16-1.71.82-1.78,1.35-.33,2.48,5.9,7.49,8.87,8.7A.38.38,0,0,0,743.7,857.11Zm-6.77-9.22c3.43,0,5.42,5.67,6.09,7.94-3.22-1.68-7.68-5.75-7.46-7.33,0-.12.06-.48,1-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M698.93,168.71l-4.12-2.11S696.38,170.45,698.93,168.71Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneboardAppealsImage);
export default __webpack_public_path__ + "static/media/oneboardAppealsImage.c0bce0c2ca83a52eeda539cb9a11a7a7.svg";
export { ForwardRef as ReactComponent };